module.exports = __webpack_public_path__ + "static/media/header_menu51028daf59c6c3dfab24aeb5fbf20bca.webp";